import React, { useContext, useEffect, useState } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import GlobalContext from "../../../contexts/globalContext";
import moment from "moment";

// Components //
import Modal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";
import IconCourses from '../../atoms/icon-courses/iconCourses';
import rawToReact from "../../../utils/rawToReact";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

// Services //
import { saveForm, getToken, getUserFormDataByQuestionId, postCursosRegionesData} from "../../../services/formServices";

// Styles //
import "./FormTallerAprendizajeCursosRegiones.scss";
import iconInfo from "../../../assets/images/icons/icon-lilac.svg"
import iconELearn from "../../../assets/images/icons/aprendizaje-electronico.svg"
import iconBook from "../../../assets/images/icons/libro-alt.svg"
import iconBookAqua from "../../../assets/images/icons/bookAquamarine.svg"
import iconUser from "../../../assets/images/icons/usuario.svg"
import iconCheck from "../../../assets/images/icons/check.svg"

// Añadir esta interfaz cerca del inicio del archivo
const FormTallerAprendizajeCursosRegiones = (props: any) => {
    const dataForm = useStaticQuery(graphql`
        query contentfulFormTallerAprendizajeCursosRegiones {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "G7foBiEVieJoh74SnT6AM" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        descripcionFija {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            maximosCaracteres
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            icon {
                                title
                                file {
                                    url
                                    fileName
                                }
                            }
                            tabOrder
                            ayuda
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccessCourse: allContentfulContactenos(
                filter: { contentful_id: { eq: "72ZmxvWsmue47TYKh64950" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);

    const defaultFormValues = {};
    const contentfulData = dataForm.form.nodes[0];
    const modalSuccessCourse =  dataForm.modalSuccessCourse.nodes[0];
    
    const Context = useContext(GlobalContext);

    const [ titulosFormularioHelper, setTitulosFormularioHelper] = useState(contentfulData.titulosFormulario);
    const [formValues, setFormValues] = useState<any>(defaultFormValues);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [isOpenModalSuccess, setIsOpenModalSuccess] = useState<boolean>(false);
    const [inputDisabled] = useState<string[]>([]);
    const [fieldsToSkip, setFieldsToSkip] = useState<string[]>([]);
    const [selectedType, setSelectedType] = useState<string>("");
    const [selectedCourses, setSelectedCourses] = useState<any[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [cancelForm, setCancelForm] = useState(false);
    const fieldsList: any = ["course_human", "course_specific", "course_key"];
    const hiddenFields = {
        ["inscrito_mentoria"]: "",
        ["asistencia_mentoria"]: "",
        ["fecha_mentoria"]: "",
        ["mentor"]: "",
        ["ccf_comfama"]: "",
        ["tipo_tit"]: "",
        ["tiempo_cotizacion"]: "",
        ["beneficio_economico"]: "",
        ["atentionTeam"]: "",
        ["contributionFee"]:"",
        ["municipality"]: "",
    };

    const { document } = useBrowserMode();

    // let inputCourses : any;
    let inputHumans: any;
    let inputSpecific: any;
    let inputKey: any;
    let selectCompetence: any;
    let selectHumans: any;
    let selectSpecific: any;
    let selectKey: any;

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone" || field === "aux_number") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    const registerDate = moment(Date.now()).format("DD-MM-YYYY");
    const updateInputValue = (field: string, value: any, type?: string) => {
        inputHumans = document.querySelector(".a-input__form-course_human");
        inputSpecific = document.querySelector(".a-input__form-course_specific");
        inputKey = document.querySelector(".a-input__form-course_key");
        selectCompetence = document.getElementById("select_competence");
        const coursesList: any = [...selectedCourses];
        let selectedFields: any[] = [];

        setFormValues({ ...formValues});
        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        if (field === "competence") {
            setSelectedType(value);

            if (value !== "") {
                selectHumans = document.getElementById("select_course_human");
                selectHumans?.removeAttribute("disabled");
            }

            if (value === "Competencias humanas") {
                inputSpecific.style.display = "none";
                inputKey.style.display = "none";
                inputHumans.style.display = "flex";
            }

            if (value === "Competencias específicas") {
                inputSpecific.style.display = "flex";
                inputKey.style.display = "none";
                inputHumans.style.display = "none";
            }

            if (value === "Competencias claves") {
                inputSpecific.style.display = "none";
                inputKey.style.display = "flex";
                inputHumans.style.display = "none";
            }
        }

        if (field === "course_human") {
            coursesList.push({type: selectedType, value: value, field: field});
            selectedFields = skipFields(coursesList);
            setSelectedCourses(coursesList);
            selectHumans = document.getElementById("select_course_human");
        }

        if (field === "course_specific") {
            coursesList.push({type: selectedType, value: value, field: field});
            selectedFields = skipFields(coursesList);
            setSelectedCourses(coursesList);
            selectSpecific = document.getElementById("select_course_specific");
        }

        if (field === "course_key") {
            coursesList.push({type: selectedType, value: value, field: field});
            selectedFields = skipFields(coursesList);
            setSelectedCourses(coursesList);
            selectKey = document.getElementById("select_course_key");
        }

        if (coursesList.length > 2) {
            const skippedList = fieldsList.filter(item => !selectedFields.includes(item));
            setFieldsToSkip(skippedList);
        } else {
            setFieldsToSkip([]);
        }
    };

    const createPayload = () => {
        const payload: any = {
            idForm: 17,
            answers: [],
        };

        const courseSelection = formValues.course_selection?.split(",") || [];
        const hiddenInputs = {
            name_course_1: courseSelection[0] ? courseSelection[0] : "",
            name_course_2: courseSelection[1] ? courseSelection[1] : "",
        };

        const updatedValues = { ...formValues, ...hiddenInputs, economicSector: formValues.economicSector };

        Object.entries(updatedValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });

        return payload;
    };

    const handleSubmitForm = async () => {
        setIsOpenModalSuccess(true);
        setDisabledButton(true);
        const payload = createPayload();
        const token = await getToken();
        const responseSubmitForm = await saveForm(payload, token);
        if (responseSubmitForm.status == 200){
            localStorage.removeItem('docNumber');
        }
        setDisabledButton(false);
    };

    const skipFields = (selectedList) => {
        const array = selectedList.map((item) => {
            return item.field
        });
        return array;
    }
    const handleCancel = () =>{
        setCancelForm(true);
    }

    const closeCancelForm = () => {
        setCancelForm(false);
    };

    const closeForm = () => {
        navigate(``);
    };

    useEffect(() => {
        const getData = async () => {
            const token = await getToken();
            const body = {
                "pageNumber": 1,
                "region": "REGIONES",
                "lugar": "",
                "palabraClave": "",
                "duracionFormacion": [],
                "modalidad": [],
                "tipoFormacion": ["Curso"],
                "rolFormativo": [formValues.economicSector?.split('Sector ')[1]]
            };

            const data = await postCursosRegionesData(body, token);

            const coursesList = data.data.content;

            if (formValues.economicSector) {
                populateCourses(coursesList, formValues.economicSector?.split('Sector ')[1].trim());
            }
        };

        getData();
    }, [formValues.economicSector]);

    const populateCourses = async (data, economicSector) => {

        try {
            setDisabledButton(true);

            const coursesList = [];
            Object.entries(data).forEach(([_, value]) => {
                if (value && typeof value === 'object') {
                    // Verifica si se pueden formar los 3 elementos
                    if ('portafolio' in value && 'duracion' in value) {
                        coursesList.push(`${value.portafolio}/${value.duracion}/${economicSector}`);
                    } else {
                        coursesList.push(economicSector);
                    }
                }
            });

            Object.entries(contentfulData.titulosFormulario[0].referenciaFormulario).forEach(([key, value]) => {
                if (value.nombreId === "course_selection") {
                    contentfulData.titulosFormulario[0].referenciaFormulario[key].listaSelect = coursesList;
                }
            });

            setTitulosFormularioHelper(coursesList);
        } catch (error) {
            console.error("Error while populating courses:", error);
        } finally {
            setDisabledButton(false);
        }
    };

    useEffect(() => {
        const docNumber = localStorage.getItem('docNumber');

        if (docNumber != undefined) {
            const getAnswersByDocNumber = async () => {
                const token = await getToken();
                return getUserFormDataByQuestionId(token, 16, "docNumber", docNumber );
            };
            getAnswersByDocNumber().then(response => {
                delete response.data.answerData.interest_workshop;
                delete response.data.answerData.workshop_offer;
                delete response.data.answerData.doc_number;
                delete response.data.answerData.document_type;
                delete response.data.answerData.municipality_of_residence;
                setFormValues({...formValues, ...response.data.answerData, ...hiddenFields, ["registerDate"]: registerDate})
            })

            const getData = async () => {
                const token = await getToken();
                const body = {
                    "pageNumber": 1,
                    "region": "REGIONES",
                    "lugar": "",
                    "palabraClave": "",
                    "duracionFormacion": [],
                    "modalidad": [],
                    "tipoFormacion": ["Curso"],
                    "rolFormativo": ["Habilidades para la vida"]
                };

                const data = await postCursosRegionesData(body,token);

                const habilidadesList = data.data.content;

                if (habilidadesList?.length > 0) {
                    populateHabilidades(habilidadesList);
                }
            };

            getData();
        } else {
            navigate(props.location.href.replace("/aprendizaje/formulario/cursos-regiones/","/aprendizaje/formulario/talleres-regiones/"));
        }
    }, [])

    const populateHabilidades = async (data) => {
        try {
            setDisabledButton(true);
            const habilidadesList = [];

            Object.entries(data).forEach(([_, value]) => {
                if (value && typeof value === 'object') {
                    // Verifica si se pueden formar los 3 elementos
                    if ('portafolio' in value && 'duracion' in value) {
                        habilidadesList.push(`${value.portafolio}/${value.duracion} horas`);
                    } else {
                        console.log(value, "value");
                    }
                }
            });

            Object.entries(contentfulData.titulosFormulario[1].referenciaFormulario).forEach(([key, value]) => {
                if (value.nombreId === "lifeSkills") {
                    contentfulData.titulosFormulario[1].referenciaFormulario[key].listaSelect = habilidadesList;
                }
            });
        } catch (error) {
            console.error("Error while populating habilidades:", error);
        } finally {
            setDisabledButton(false);
        }
    };

    return (
        <>
            {!isOpenModalSuccess && <div className="o-form-taller-aprendizaje-cursos-regiones">
                <FormHead
                    tituloPrincipal={contentfulData.tituloPrincipal}
                    descripcion={contentfulData.descripcion}
                    tituloFormulario={
                        contentfulData.tituloFormulario
                    }
                    descripcionFormulario={
                        contentfulData.descripcionFormulario.json
                    }
                >
                </FormHead>
                {currentIndex === 2 && (
                        <div className="modal-form-courses-regiones__verification" >
                            <h2 className="modal-form-courses-regiones__verification__title"><img src={iconCheck} alt="icono info" />Verifica las opciones seleccionadas antes de continuar</h2>
                            <div className="modal-form-courses-regiones__verification__container">
                                <div className="modal-form-courses-regiones__verification__options">
                                    <h3><img src={iconUser} alt="icono info" /> Enfoque: {formValues.economicSector?.replace("Sector ", "")}</h3>
                                    {formValues.course_selection && formValues.course_selection.split(",").map((course, index) => (
                                        <p key={index}><img src={iconBook} alt="icono info" /><strong> Curso {index + 1}:</strong> {course}</p>
                                    ))}
                                </div>
                                <div className="modal-form-courses-regiones__verification__options">
                                    <p><img src={iconUser} alt="icono info" />
                                        <strong>Curso para la vida:</strong> {formValues.lifeSkills ? formValues.lifeSkills.split('/')[0] : "N/A"}</p>
                                </div>
                            </div>
                            <div className="modal-form-courses-regiones__disclaimer__container">
                                <h2 className="modal-form-courses-regiones__disclaimer__title">La modalidad de los cursos se encuentra sujeta a la disponibilidad del momento.</h2>
                                <p className="modal-form-courses-regiones__disclaimer">
                                    <img src={iconELearn} alt="icono info" />
                                    <span>
                                        Recuerda que para tomar un curso en <strong>modalidad virtual</strong> necesitas acceso a internet y un dispositivo como una computadora o un celular para conectarte.
                                    </span>
                                </p>
                                <p className="modal-form-courses-regiones__disclaimer">
                                    <img src={iconBookAqua} alt="icono info" />
                                    <span>
                                        Para la <strong>modalidad presencial</strong> es importante que dispongas de tiempo y recursos para desplazarte al lugar en el que se dictará la formación.
                                    </span>
                                </p>
                            </div>
                            <div className="a-button-magenta-container">
                            </div>
                        </div>
                    )}
                <FormBody
                    titulosFormulario={
                        contentfulData.titulosFormulario
                    }
                    genericClassNameForm={contentfulData.metaTitulo}
                    setInputValue={updateInputValue}
                    formValues={formValues}
                    handleSubmitForm={handleSubmitForm}
                    inputDisabled={inputDisabled}
                    isDisabledButton={isDisabledButton}
                    fieldsToSkip={fieldsToSkip}
                    handleCancelButton={handleCancel}
                    setCurrentIndex={setCurrentIndex}
                >
                    {cancelForm && (
                        <Modal
                            showModal={cancelForm}
                            onClose={closeCancelForm}>
                                <div
                                    className={`m-modal-container-validation`}
                                >
                                    <h3>¿Estas seguro que quieres cancelar el proceso de inscripción?</h3>
                                    <div className="a-button-magenta-container__modal-cancelar">
                                        <Button
                                        type="button"
                                        classname="a-button-magenta"
                                        text={"No, quiero regresar"}
                                        isDisabled={false}
                                        onClickAction={() => {
                                            closeCancelForm()
                                        }}
                                        >
                                        </Button>
                                    </div>
                                    <div>
                                    <Button
                                        type="button"
                                        classname="a-button-magenta__cancelar-modal"
                                        text={"Sí, quiero"}
                                        isDisabled={false}
                                        onClickAction={() => {
                                            closeForm()
                                        }}
                                        >
                                </Button>
                                    </div>
                                </div>
                        </Modal>
                    )}
                </FormBody>
            </div>}
            {isOpenModalSuccess && (
            <div className="modal-form-courses-regiones__success" >
                <h1 className="modal-form-courses-regiones__success__title">Finalizaste tu inscripción a nuestra Ruta de aprendizaje.</h1>
                <p className="modal-form-courses-regiones__success__description">
                    Validaremos que cumplas con algunos requisitos y nos comunicaremos contigo próximamente para dar inicio a tu proceso de aprendizaje.
                </p>
                <p className="modal-form-courses-regiones__success__description">
                    <strong>
                        Te recomendamos estar atento a tu celular o correo electrónico.
                    </strong>
                </p>

                <div className="modal-form-courses-regiones__success__container">
                    <div className="modal-form-courses-regiones__success__section">
                        <h3 className="modal-form-courses-regiones__success__section__title">Selección de cursos:</h3>
                        <div className="modal-form-courses-regiones__success__section__flex">
                            <p className="modal-form-courses-regiones__success__section__text">
                                <strong>Sector:</strong> {formValues.economicSector?.replace("Sector ", "")}
                            </p>
                            {formValues.course_selection && formValues.course_selection.split(",").map((course, index) => (
                                <p key={index} className="modal-form-courses-regiones__success__section__text">
                                    <strong>Curso {index + 1}:</strong> {course}
                                </p>
                            ))}
                        </div>
                    </div>

                    <div className="modal-form-courses-regiones__success__section">
                        <h3 className="modal-form-courses-regiones__success__section__title">Curso de habilidades para la vida:</h3>
                        <p className="modal-form-courses-regiones__success__section__text">
                            <strong>Curso transversal:</strong> {formValues.lifeSkills ? formValues.lifeSkills.split('/')[0] : "N/A"}
                        </p>
                    </div>
                </div>
                
                <div className="modal-form-courses-regiones__success__footer">
                    <img src={iconInfo} alt="iconInfo" />
                    <p className="modal-form-courses-regiones__success__footer__text">
                        <span>
                            Para acceder a los cursos, debes estar actualmente sin empleo y haber realizado aportes los últimos 3 años a Caja de Compensación Familiar, acumulando un período total de cotización de 1 año como trabajador dependiente y de 2 años como independiente.
                            Asistiendo a nuestros cursos estarás cumpliendo con uno de los requisitos para aplicar al
                            <strong className="subsidio-modal">
                                <a href="https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo/" target="_blank" rel="noopener noreferrer">&nbsp;Subsidio al desempleo.</a>
                            </strong>
                        </span>
                    </p>
                </div>
                <a href="https://www.comfama.com/servicio-de-empleo/personas/vacantes-en-antioquia/">
                    <Button
                        type="button"
                        classname="a-button  a-button__magenta m-form-bottom__navigation-button-next gtmFormButton-Siguiente"
                        text={"Ver Vacantes"}
                        isDisabled={false}
                    >
                    </Button>
                </a>
            </div>
            )}
        </>
    )
};

export default FormTallerAprendizajeCursosRegiones;